import * as $ from "jquery";

import { getIEVersion } from "./utility";

declare global {
    interface Document {
        documentMode?: any;
    }
}

const tints: Array<string> = ["light", "medium", "dark"];

export class homeSlider2 {
    $homeslider: JQuery;
    $herosvisible: JQuery<Element>;
    heroCount: number;
    containers: JQuery;
    images: Array<string>;
    imagePath: string;
    intervalSwap: number;
    intervalGlass: number;
    swapIndex: number;
    currentImages: Array<number>;
    imageIndexes: Array<number>; // for easy image selection

    /* constructor */
    constructor(images: Array<string>, imagePath: string) {
        this.images = images;
        this.imagePath = imagePath;
        this.$homeslider = $(".home-slider2");
        this.intervalSwap = 0;
        this.currentImages = [0, 1, 2, 3];

        // simple array 0...n
        this.imageIndexes = this.images.map((v, idx) => idx);
    }

    run() {
        const self = this;

        self.setupGlass();

        /* ---- RUN SLIDER ---- */
        self.calcHeros();
        self.startRotateImages();
        self.startTintGlass();

        /* Modify the # of containers based on screen size */
        $(window).on("resize", function () {
            self.calcHeros();
        });
    }

    // Add inital tints to all glass
    setupGlass() {
        const self = this;
        self.$homeslider.find(".hero-block")
            .each(function () {
                const $hero = $(this);
                const $glass = $hero.find(".glass");
                $glass.each(function () {
                    $(this).addClass(tints[self.getRandom(tints)]);
                });
            });
    }

    // start rotating images. Probably not necessary to have a start
    // and stop function but can't hurt to leave it here
    startRotateImages() {
        const self = this;
        self.stopRotateImages();
        self.intervalSwap = window.setInterval(() => self.rotateImages(), 5000);
    }

    stopRotateImages() {
        if (this.intervalSwap) {
            window.clearInterval(this.intervalSwap);
            this.intervalSwap = 0;
        }
    }

    startTintGlass() {
        const self = this;
        self.stopTintGlass();
        self.intervalGlass = window.setInterval(() => self.tintGlass(), 500);
    }

    stopTintGlass() {
        if (this.intervalGlass) {
            window.clearInterval(this.intervalGlass);
            this.intervalGlass = 0;
        }
    }

    // Rotate a random image
    rotateImages() {
        const self = this;

        this.swapIndex = this.getHeroRandomIndexSkip(this.swapIndex);
        const $swapHero = this.$herosvisible.slice(
            this.swapIndex,
            this.swapIndex + 1,
        );
        const newImageIndex = this.getRandomImageIndex();
        const newImage = `url(${this.imagePath}${this.images[newImageIndex]})`;

        $swapHero.css("background-image", newImage);
        const $glass = $swapHero.find(".glass");

        $glass.each(function () {
            const delayTime = Math.floor(Math.random() * 40) * 25;
            const $glass = $(this);
            window.setTimeout(() => {
                self.rotateGlass($glass, newImage);
            }, delayTime);
        });

        this.currentImages[this.swapIndex] = newImageIndex;
        //this.debugSwapState();
    }

    // Handle replacing a glass element with a new one
    rotateGlass($glass, newImage: string) {
        // old way with css animations
        //$glass.css('background-image', newImage);
        const $glassclone = $glass.clone();
        $glassclone.appendTo($glass.parent());
        $glass.css("background-image", newImage);
        $glassclone.fadeOut(500, () => {
            $glassclone.remove();
        });
    }

    // tint a random glass
    tintGlass() {
        const self = this;
        const heroIndex = this.getHeroRandomIndex();
        const $hero = this.$herosvisible.slice(heroIndex, heroIndex + 1);
        const $glass = $hero.find(".glass");
        const glassIndex = Math.floor(Math.random() * $glass.length);
        const $glassfade = $glass.slice(glassIndex, glassIndex + 1);
        $glassfade
            .removeClass("light medium dark")
            .addClass(tints[self.getRandom(tints)]);
    }

    // Debugging purposes show the images displayed. Not normally used in production
    debugSwapState() {
        let message = "[";
        for (var idx = 0; idx < this.heroCount; ++idx) {
            if (idx > 0) {
                message += ",";
            }
            message += this.currentImages[idx];
        }
        message += "]";
        console.log(message);
    }

    // get a random hero but skip the number provided if possible
    // this ensures we're always rotating something new
    getHeroRandomIndexSkip(skip: number): number {
        if (this.heroCount <= 1) {
            return 0;
        }
        if (skip < 0) {
            return this.getHeroRandomIndex();
        }
        const idx = Math.floor(Math.random() * (this.heroCount - 1));
        if (idx >= skip) {
            return idx + 1;
        } else {
            return idx;
        }
    }

    // Gets a random hero (no skip)
    getHeroRandomIndex(): number {
        if (this.heroCount <= 1) {
            return 0;
        }
        return Math.floor(Math.random() * this.heroCount);
    }

    // Calculate which heros are visible and thus which images are visible
    // needs to be done on resize so we don't work on hidden images
    calcHeros() {
        this.$herosvisible = this.$homeslider.find(".hero-block:visible");
        this.swapIndex = -1; // so we can pick any one!
        this.heroCount = this.$herosvisible.length;
    }

    // ----- HELPER FUNCTIONS ----- //
    // Returns a random value based on an array's length
    getRandom(arr: Array<any>): number {
        return Math.floor(Math.random() * arr.length);
    }

    // Picks a new random image from an array
    // Excludes any images already displayed
    getRandomImageIndex(): number {
        // get an array of images
        const self = this;
        const pickList = self.imageIndexes.filter((iImage) => {
            for (let iCurrent of self.currentImages) {
                if (iCurrent === iImage) {
                    return false;
                }
            }
            return true;
        });
        return pickList[self.getRandom(pickList)];
    }
}
